var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailServiceStrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 292,
    viewBox: "0 0 292 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 292,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3734 138.669L19 126.76L54.6097 114L89.7593 126.76L54.3734 138.669Z",
    fill: "url(#paint0_linear_2417_2104)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6097 113L19 125.76V166.821L54.3734 178.73L89.7593 166.821V125.76L54.6097 113Z",
    fill: "url(#paint1_linear_2417_2104)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3839 137.669V178.731L89.7698 166.822V125.76",
    fill: "url(#paint2_linear_2417_2104)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3847 178.731L19.0112 166.822V125.76L54.3847 137.669V178.731Z",
    fill: "url(#paint3_linear_2417_2104)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.137 120.817L82.0284 122.955L54.6345 132.209L35.0212 125.61L62.3655 115.805L54.622 113L19 125.76L54.3859 137.657V178.719L89.7718 166.821V125.76L76.137 120.805V120.817ZM84.1538 163.177L59.9666 171.316V135.795L84.1538 127.657V163.177Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.148 150.268C119.705 152.567 121.356 153.912 124.42 153.912C127.821 153.912 129.124 152.337 129.124 150.463C129.124 148.59 128.193 147.314 124.086 146.371C120.102 145.451 118.39 144.244 118.39 141.75C118.39 139.451 120.202 137.324 124.222 137.324C128.243 137.324 130.116 139.658 130.352 141.773H128.8C128.379 139.934 127.076 138.589 124.148 138.589C121.468 138.589 120.004 139.738 120.004 141.658C120.004 143.578 121.232 144.29 124.669 145.084C129.942 146.302 130.736 148.256 130.736 150.348C130.736 152.912 128.714 155.119 124.359 155.119C119.668 155.119 117.943 152.602 117.584 150.245H119.135L119.148 150.268Z",
    fill: "#2C2C2C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.542 138.853H132.264V137.577H146.384V138.853H140.081V154.947H138.554V138.853H138.542Z",
    fill: "#2C2C2C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.677 146.854V154.947H149.15V137.577H155.9C159.611 137.577 161.571 139.416 161.571 142.152C161.571 144.359 160.157 145.796 158.084 146.222C159.995 146.647 161.273 147.796 161.273 150.762V151.441C161.273 152.659 161.174 154.291 161.521 154.958H159.995C159.648 154.211 159.723 152.831 159.723 151.326V150.877C159.723 148.049 158.817 146.854 155.243 146.854H150.677ZM150.677 145.578H155.18C158.456 145.578 159.97 144.44 159.97 142.175C159.97 140.06 158.481 138.853 155.578 138.853H150.677V145.578Z",
    fill: "#2C2C2C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.783 146.14C181.783 150.876 179.04 155.199 173.246 155.199C167.96 155.199 164.871 151.256 164.871 146.267C164.871 141.278 167.849 137.335 173.432 137.335C178.581 137.335 181.771 141.082 181.771 146.14H181.783ZM166.496 146.186C166.496 150.164 168.866 153.911 173.333 153.911C178.159 153.911 180.17 150.256 180.17 146.163C180.17 142.071 177.887 138.611 173.382 138.611C168.594 138.611 166.496 142.278 166.496 146.186Z",
    fill: "#2C2C2C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.879 154.947V137.577H188.088C190.99 141.738 197.803 151.383 198.968 153.268H198.993C198.832 150.774 198.857 148.21 198.857 145.382V137.577H200.384V154.947H198.336C195.569 150.946 188.646 140.888 187.318 138.968H187.293C187.43 141.233 187.405 143.785 187.405 146.934V154.935H185.879V154.947Z",
    fill: "#2C2C2C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M220.086 154.947H218.846C218.734 154.74 218.684 153.854 218.66 152.188C217.977 153.383 216.5 155.142 212.616 155.142C207.232 155.142 204.465 151.349 204.465 146.406C204.465 141.221 207.417 137.324 212.915 137.324C216.972 137.324 219.652 139.301 220.247 142.497H218.746C217.953 140.072 216.128 138.612 212.865 138.612C208.2 138.612 206.078 141.98 206.078 146.337C206.078 150.291 208.125 153.866 212.679 153.866C217.232 153.866 218.635 151.05 218.635 147.256V147.061H212.629V145.785H220.086V154.958V154.947Z",
    fill: "#2C2C2C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.926 137.577H231.489C235.1 137.577 237.023 139.347 237.023 141.853C237.023 143.911 235.683 145.245 234.144 145.647C235.485 145.992 237.693 147.21 237.693 149.935C237.693 153.395 234.889 154.947 231.601 154.947H224.926V137.577ZM231.017 145.038C234.232 145.038 235.447 143.923 235.447 141.934C235.447 140.233 234.169 138.853 231.564 138.853H226.402V145.038H231.017ZM226.402 153.671H231.638C234.094 153.671 236.13 152.533 236.13 150.004C236.13 147.808 234.616 146.314 230.868 146.314H226.39V153.671H226.402Z",
    fill: "#2C2C2C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M257.533 146.14C257.533 150.876 254.791 155.199 248.997 155.199C243.711 155.199 240.621 151.256 240.621 146.267C240.621 141.278 243.599 137.335 249.183 137.335C254.332 137.335 257.521 141.082 257.521 146.14H257.533ZM242.247 146.186C242.247 150.164 244.617 153.911 249.083 153.911C253.91 153.911 255.921 150.256 255.921 146.163C255.921 142.071 253.637 138.611 249.133 138.611C244.344 138.611 242.247 142.278 242.247 146.186Z",
    fill: "#2C2C2C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M271.814 154.947L266.193 147.164H266.168L260.597 154.947H258.848L265.25 146.118L259.121 137.577H260.871L266.193 144.957H266.218L271.653 137.577H273.39L267.074 146.015L273.576 154.947H271.801H271.814Z",
    fill: "#2C2C2C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2417_2104",
    x1: 58.388,
    y1: 140.025,
    x2: 43.7222,
    y2: 83.2877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2417_2104",
    x1: 65.2614,
    y1: 182.317,
    x2: 26.1313,
    y2: 30.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2417_2104",
    x1: 41.731,
    y1: 126.668,
    x2: 90.4794,
    y2: 174.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2417_2104",
    x1: -21.8062,
    y1: 196.307,
    x2: 43.9251,
    y2: 138.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailServiceStrong);
export default __webpack_public_path__ + "static/media/DetailServiceStrong.eba7d319bc2a288867e75298c3d90e31.svg";
export { ForwardRef as ReactComponent };